import { render, staticRenderFns } from "./IssuancePage.vue?vue&type=template&id=839e3448"
import script from "./IssuancePage.vue?vue&type=script&lang=js"
export * from "./IssuancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports